import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateTicketTimeTracking } from '../../../../state';
import { toLocalDateTimeString, fromLocalDateTimeString } from '../../../../../../utils/DateConversions';

const CreatedDateEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentTicket } = useAppSelector(state => state.ticket);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateTicketTimeTracking({ createdDate: fromLocalDateTimeString(event.target.value) }));
  };

  return (
    <TextField
      label="Created Date"
      size="small"
      type="datetime-local"
      fullWidth
      value={currentTicket?.timeTracking.createdDate ? toLocalDateTimeString(currentTicket.timeTracking.createdDate) : ''}
      onChange={handleChange}
      InputLabelProps={{ shrink: true }}
      disabled // Usually auto-set, but allow editing if needed
    />
  );
};

export default CreatedDateEdit;
